import { useRef } from "react";
import type { RefObject } from "react";

export const useTemporaryRef = <T,>(reference?: RefObject<T | null> | null) => {
  const tempRef = useRef<T | null>(null);
  return reference || tempRef;
};
